var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"container",attrs:{"to":'/group/'+_vm.group.id+'/news/init'}},[_c('div',{staticClass:"flex-container",style:(_vm.getDynamicStyle())},[_c('div',[_vm._v(" "+_vm._s(_vm.group.name)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }